const useStyles = () => {
    let dateLabelSx = {
        mt: (theme) => theme.spacing(1),
        fontSize: '0.85rem',
        fontWeight: 500,
        color: (theme) => theme.palette.grey.header,
    };

    let dateTextFieldSx = {
        width: '9rem',
        '& .MuiOutlinedInput-root': {
            fontSize: '0.8125rem',
        },
        '& .MuiIconButton-sizeMedium': {
            padding: 0,
        },
        '& .Mui-disabled': {
            backgroundColor: (theme) => theme.palette.grey['disabled-background'],
            color: '#586874',
            WebkitTextFillColor: 'unset',
            fontWeight: 400,
            '& fieldset': {
                border: 'none',
            },
        },
    };

    return {
        dateLabelSx,
        dateTextFieldSx,
    };
};

export default useStyles;
